import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { Sidebar } from '@/components/layout/Sidebar';
import { Header } from '@/components/dashboard/Header';
import { ThreatIntelligence } from '@/pages/ThreatIntelligence';
import { RansomwareIntelligence } from '@/pages/RansomwareIntelligence';
import { BreachMonitoring } from '@/pages/BreachMonitoring';
import { VulnerabilityDatabase } from '@/pages/VulnerabilityDatabase';
import { Integrations } from '@/pages/Integrations';
import { Settings } from '@/pages/Settings';
import AIThreatProfiling from '@/pages/AIThreatProfiling'; // Import the new page
import { Button } from '@/components/ui/button';
import { Menu } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { MainBackground } from './MainBackground';

export function Layout() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    console.log('[Layout] Mounted');
    return () => console.log('[Layout] Unmounted');
  }, []);

  useEffect(() => {
    console.log('[Layout] Location changed:', location.pathname);
  }, [location]);


  return (
    <div className="flex h-screen bg-background/95 backdrop-blur-sm">
      <MainBackground />
      {/* Desktop Sidebar */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      <div className="flex flex-1 flex-col">
        {/* Mobile Menu Button */}
        <div className="md:hidden absolute left-4 top-4 z-50">
          <Sheet open={isMobileMenuOpen} onOpenChange={setIsMobileMenuOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon">
                <Menu className="h-5 w-5" />
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="p-0 w-64">
              <Sidebar onNavigate={() => setIsMobileMenuOpen(false)} />
            </SheetContent>
          </Sheet>
        </div>

        {/* Header and Main Content */}
        <div className="flex-1 overflow-hidden bg-muted/50">
          <Header />
          <main className="overflow-y-auto h-[calc(100vh-4rem)]">
            <div className="md:pt-0 pt-8">
              <Routes>
                <Route path="/" element={<AIThreatProfiling />} /> {/* Changed to AIThreatProfiling */}
                <Route path="/threat-intelligence" element={<ThreatIntelligence />} />
                <Route path="/dark-web" element={<BreachMonitoring />} />
                <Route path="/ransomware" element={<RansomwareIntelligence />} />
                <Route path="/vulnerabilities" element={<VulnerabilityDatabase />} />
                <Route path="/integrations" element={<Integrations />} />
                <Route path="/settings" element={<Settings />} />
                {/* <Route path="/ai-threat-profiling" element={<AIThreatProfiling />} /> */} {/* Removed old route */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}